/**
 * Droit de suite (barème français dégressif).
 *
 * Seuil : 750 €. Barème par tranches sur le prix de vente hors taxes :
 * 4 % jusqu'à 50 000 €, 3 % de 50 000,01 à 200 000 €, 1 % de 200 000,01 à
 * 350 000 €, 0,5 % de 350 000,01 à 500 000 €, 0,25 % au-delà.
 * Plafond : 12 500 €.
 *
 * Le barème est aussi rangé dans `tax_profile` pour qu'une galerie puisse le
 * faire valider par son expert-comptable ; celui-ci en est la valeur par défaut.
 */
import { arrondirCentimes } from './arrondi.js';
/** Seuil de déclenchement : 750 €. */
export const SEUIL_DROIT_DE_SUITE_CENTIMES = 75_000;
/** Plafond par vente : 12 500 €. */
export const PLAFOND_DROIT_DE_SUITE_CENTIMES = 1_250_000;
/** Le barème français, en centimes et en points de base. */
export const BAREME_DROIT_DE_SUITE = {
    seuilCentimes: SEUIL_DROIT_DE_SUITE_CENTIMES,
    plafondCentimes: PLAFOND_DROIT_DE_SUITE_CENTIMES,
    tranches: [
        { plafondCentimes: 5_000_000, tauxPointsDeBase: 400 },
        { plafondCentimes: 20_000_000, tauxPointsDeBase: 300 },
        { plafondCentimes: 35_000_000, tauxPointsDeBase: 100 },
        { plafondCentimes: 50_000_000, tauxPointsDeBase: 50 },
        { plafondCentimes: null, tauxPointsDeBase: 25 },
    ],
};
/**
 * Le droit de suite dû sur une vente, en centimes.
 *
 * En dessous du seuil, rien. Au-dessus, le barème s'applique tranche par
 * tranche, puis le plafond coupe.
 */
export function calculerDroitDeSuite(prixVenteCentimes, bareme = BAREME_DROIT_DE_SUITE) {
    if (prixVenteCentimes < bareme.seuilCentimes)
        return 0;
    let du = 0;
    let borneBasse = 0;
    for (const tranche of bareme.tranches) {
        const borneHaute = tranche.plafondCentimes ?? prixVenteCentimes;
        const assiette = Math.min(prixVenteCentimes, borneHaute) - borneBasse;
        if (assiette > 0) {
            du += arrondirCentimes((assiette * tranche.tauxPointsDeBase) / 10_000);
        }
        borneBasse = borneHaute;
        if (prixVenteCentimes <= borneHaute)
            break;
    }
    return Math.min(du, bareme.plafondCentimes);
}
//# sourceMappingURL=droit-de-suite.js.map